import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import AkSelect, { type StylesConfig } from '@atlaskit/select';
import { token } from '@atlaskit/tokens';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import type { Condition } from '../../../../../../../../../common/types';
import messages from './messages';

const SelectFieldView = ({
	intl: { formatMessage },
	conditionsList,
	onSelect,
	isNewConditionAdded,
	setNewConditionAdded,
}: Intl & {
	conditionsList: Condition[];
	onSelect: (condition: Condition) => void;
	isNewConditionAdded: boolean;
	setNewConditionAdded: (value: boolean) => void;
}) => {
	const onChange = (option: { label: string; value: string }) => {
		const selectedCondition = conditionsList.find(
			(condition) => condition.conditionId === option.value,
		);

		if (selectedCondition) {
			setNewConditionAdded(false);
			onSelect(selectedCondition);
		}
	};

	return (
		<Box xcss={selectBoxWrapperStyles}>
			{conditionsList && isNewConditionAdded && (
				<div
					key="Select-newCondition"
					data-test-id="servicedesk-sla-settings.ui.metrics.metric.editable.form.conditions.condition.fields.select-field.ak-select"
				>
					<AkSelect
						options={conditionsList.map((condition) => ({
							label: condition.name,
							value: condition.conditionId,
						}))}
						// @ts-expect-error - TS2322 - Type '(option: {    label: string;    value: string;}) => void' is not assignable to type '(value: { label: string; value: string; } | null, action: ActionMeta<{ label: string; value: string; }>) => void'.
						onChange={onChange}
						placeholder={formatMessage(messages.selectCondition)}
						styles={customStyles}
						onBlur={() => setNewConditionAdded(false)}
						autoFocus
						menuIsOpen
					/>
				</div>
			)}
		</Box>
	);
};

export const SelectField = injectIntl(SelectFieldView);

const selectBoxWrapperStyles = xcss({
	marginBottom: 'space.100',
});

const customStyles: StylesConfig<{ label: string; value: string }> = {
	container: (styles) => ({
		...styles,
		marginTop: token('space.100', '8px'),
	}),
};
